import React from "react";
import { Modal } from "@mui/material";
import "./SavingProgressModal.scss";

/**
 * SavingProgressModal component
 * @param {Object} props
 * @param {boolean} props.open - Controls whether the modal is visible.
 * @param {Function} [props.onClose] - Optional callback triggered when the modal is closed.
 */
const SavingProgressModal = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && onClose) {
          onClose();
        }
      }}
      disableEscapeKeyDown
      className="saving-progress-modal"
    >
      <div className="saving-progress-modal-card">
        <div className="saving-spinner" />
        <h3 className="saving-title">Saving your progress…</h3>
        <p className="saving-subtitle">
          This may take a few moments. Please wait.
        </p>
      </div>
    </Modal>
  );
};

export default SavingProgressModal;